<template>
    <div
        :id="
            content.columnId && content.columnId[$i18n.locale]
                ? content.columnId[$i18n.locale].current
                : content._key
        "
        :class="{ center: isCentered, right: isRightAlign, flatfat: isFlatFat }"
        :style="
            `color:${calcColor(
                content.fontColor,
                colors.graphite
            )};background-color:${calcBGColor(content.bgColor, colors.white)}`
        "
    >
        <!-- <pre>{{ content.icon }}</pre> -->
        <div v-if="content.icon && content.icon.length > 0">
            <div class="headingBlurbLink-icon--default">
                <fa :icon="['fal', content.icon[0].snake]" class="fa-lg" />
            </div>
        </div>
        <div v-if="content.heading && content.heading[$i18n.locale]">
            <component
                :is="content.headingMarkup || 'h2'"
                :class="
                    `font-${headingSize}${headingUppercase ? ' uppercase' : ''}`
                "
                >{{ content.heading[$i18n.locale] }}</component
            >
        </div>
        <div
            v-if="content.blurbage && content.blurbage[$i18n.locale]"
            :style="`${content.dense ? '' : ''}`"
        >
            <BlockContent
                :blocks="content.blurbage[$i18n.locale]"
                :serializers="serializers"
            />
        </div>
        <div
            v-if="content.ctaLinks && content.ctaLinks.links"
            class="headingBlurbLink-a--default mt-4"
        >
            <CtaLinks :links="content.ctaLinks.links" />
        </div>
    </div>
</template>
<script>
import CtaLinks from '~/components/CtaLinks.vue'
import colorUtilities from '~/mixins/colorUtilities'
import serializers from '~/util/sanity/serializers'
export default {
    name: 'ColumnHeadingBlurbLink',
    components: {
        CtaLinks
    },
    mixins: [colorUtilities],
    props: {
        content: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            serializers
        }
    },
    computed: {
        headingSize() {
            if (!this.content.headingSize) {
                return 'h2'
            } else {
                return this.content.headingSize
            }
        },
        headingUppercase() {
            return this.content.headingUppercase === true
        },
        isCentered() {
            return this.content.textAlign === 'center'
        },
        isRightAlign() {
            return this.content.textAlign === 'right'
        },
        isFlatFat() {
            return this.content.stylePreset === 'flatfat'
        }
    }
}
</script>
